<div class="org-announcements__container">
  <dgx-org-announcements
    *ngIf="orgAnnouncementNotification"
    mode="live"
    [orgAnnouncements]="orgAnnouncementNotification.parameters"
    (dismissEvent)="dismissOrgAnnouncements()"
    class="grid__col-12 guts-m-b-0"
  ></dgx-org-announcements>
  <ng-content select="dgx-org-announcements"></ng-content>
</div>

<h2 class="h2 font-semibold guts-p-v-1-half guts-p-h-1-quart">
  {{ discoverHeader }}
</h2>
<dgx-suggested-section
  *ngFor="let section of sections; index as $index; trackBy: trackByFn"
  [attr.data-dgprop-section-index]="$index"
  [attr.data-dgprop-section-type]="(section.section$ | async)?.resourceSection"
  [attr.data-dgprop-section-item-count]="
    (section.section$ | async)?.resourceSuggestions.length
  "
  [perRow]="rowLength"
  [isExpanded]="section.isExpanded"
  [isLoading]="section.isLoading"
  [isLoadingMore]="section.isLoadingMore"
  [loadMore]="loadMore"
  [section]="section.section$ | async"
  [sectionIndex]="$index"
  [expectedResourceSection]="(section.section$ | async)?.resourceSection"
  (toggleExpanded)="toggleExpanded($index, $event)"
  dgxIntersectionObserver
  (onIntersection)="sectionImpressed($index, $event)"
  data-dgat="learner-home-2d0"
>
</dgx-suggested-section>
